import { SchoolReportModulesUIProvider } from "./SchoolReportModulesUIContext";
import { SchoolReportModulesCard } from "./SchoolReportModulesCard";

export function SchoolReportModulesPage({
  reportId,
  term,
  goNext
}) {
  return (
    <SchoolReportModulesUIProvider term={term}>
      <SchoolReportModulesCard
        reportId={reportId}
        goNext={goNext}
      />
    </SchoolReportModulesUIProvider>
 );
}